import React, { useCallback, useEffect } from "react";
import { RootStateOrAny, useDispatch, useSelector } from "react-redux";
import { useHistory, useParams } from "react-router";
import {
  clearPositionValues,
  fetchPosition,
  updatePosition,
} from "../../../redux/position/action";
import { FETCH_POSITION_REQUEST } from "../../../redux/position/actionType";
import { clearSpecificRequest } from "../../../redux/request/action";
import { UPDATE_USER_REQUEST } from "../../../redux/user/actionType";
import { Alert } from "../../atoms/Alert";
import { Loader } from "../../atoms/Loader";
import { PositionType } from "../../organisms/PositionForm/PositionForm";
import { LoaderWrapper } from "../../templates/UpdateUser/elements";
import UpdatePositionPage from "./UpdatePositionPage";

const UpdatePositionPageContainer = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { id } = useParams<{ id: string }>();

  const dispatchUpdatePosition = useCallback(
    (id: string, data: Partial<PositionType>) =>
      dispatch(updatePosition(id, data)),
    [dispatch]
  );

  const request = useSelector(
    (state: RootStateOrAny) => state.requestStore?.[FETCH_POSITION_REQUEST]
  );

  const position = useSelector(
    (state: RootStateOrAny) =>
      state.requestStore?.[FETCH_POSITION_REQUEST]?.response
  );

  const isUpdating = useSelector(
    (state: RootStateOrAny) => state.position?.isUpdating
  );

  const updateSuccessful = useSelector(
    (state: RootStateOrAny) => state.position?.updateSuccessful
  );

  const error = useSelector((state: RootStateOrAny) => state.position?.error);

  useEffect(() => {
    dispatch(fetchPosition(id));

    return () => {
      dispatch(clearSpecificRequest(FETCH_POSITION_REQUEST));
      dispatch(clearSpecificRequest(UPDATE_USER_REQUEST));
      dispatch(clearPositionValues());
    };
  }, [dispatch, id]);

  useEffect(() => {
    if (updateSuccessful) {
      return history.push("/admin/positions");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updateSuccessful]);

  const _updatePosition = (data: Partial<PositionType>) => {
    dispatchUpdatePosition(id, data);
  };

  return (
    <>
      {request?.isLoading || isUpdating ? (
        <LoaderWrapper>
          <Loader />
        </LoaderWrapper>
      ) : (
        <UpdatePositionPage
          position={position}
          updatePosition={_updatePosition}
        />
      )}
      {error && <Alert type="error" message={error} showIcon />}
    </>
  );
};

export default UpdatePositionPageContainer;
